import ChatListAttachment from "./ChatListAttachment";

export default ChatListAttachment;
